import {
  ChangeDetectionStrategy,
  Component,
  Input
} from '@angular/core';

import { SkyDefinitionListService } from './definition-list.service';


export class SkyDefinitionListComponent {

  // TODO: figure out how to manage state here.
  
  public set labelWidth(value: string) {
    this.service.labelWidth.next(value);
  }

  
  public set defaultValue(value: string) {
    this.service.defaultValue.next(value);
  }

  constructor(
    public service: SkyDefinitionListService) { }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-definition-list',
  template: `<div class="sky-definition-list">
  <ng-content select="sky-definition-list-heading"></ng-content>
  <ng-content select="sky-definition-list-content"></ng-content>
</div>
`,
  styles: [`.sky-definition-list {
  margin-right: 50px;
  margin-bottom: 20px;
}
`],
  providers: [SkyDefinitionListService],
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyDefinitionListService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'labelWidth': [{ type: Input },],
'defaultValue': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
